<ion-content class="content-shared">
  <ion-button mat-fab shareButton="whatsapp" #wtsBtn [url]="link" class="background_icon_whatsapp"
    (click)="onDissmis()">
    <ion-icon class="icon_whatsapp" name="logo-whatsapp"></ion-icon>
  </ion-button>
  <ion-button mat-fab shareButton="facebook" #fbBtn [url]="link" class="background_icon_facebook" (click)="onDissmis()">
    <ion-icon class="ion_facebook" name="logo-facebook"></ion-icon>
  </ion-button>
</ion-content>